var _path, _path2, _path3, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#212121",
  d: "M17.11 0H9.205C8.88 0 8.88.134 8.88.35s-.024.431.325.431h7.903c.216 0 .391.175.391.39v17.657c0 .216-.175.39-.39.39H2.89a.39.39 0 0 1-.39-.39V6.834c0-.26-.186-.26-.402-.26s-.38 0-.38.26v11.994c0 .646.526 1.172 1.173 1.172h14.218c.646 0 1.172-.526 1.172-1.172V1.172C18.281.526 17.756 0 17.11 0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#212121",
  d: "M10 1.563q-.4 0-.794.06a.39.39 0 0 0 .119.772q.335-.051.675-.051a4.42 4.42 0 0 1 4.414 4.414c0 1.08-.39 2.072-1.038 2.84a3.9 3.9 0 0 0-2.039-1.706c.356-.348.577-.833.577-1.368v-.381A1.916 1.916 0 0 0 10 4.229a1.916 1.916 0 0 0-1.914 1.914v.38c0 .536.222 1.02.577 1.369A3.907 3.907 0 0 0 6.62 9.605a4.4 4.4 0 0 1-.973-2.111.39.39 0 0 0-.77.129A5.2 5.2 0 0 0 10 11.953a5.2 5.2 0 0 0 5.195-5.195A5.2 5.2 0 0 0 10 1.563m-1.133 4.58a1.134 1.134 0 0 1 2.266 0v.38a1.134 1.134 0 0 1-2.266 0zM10 11.172a4.4 4.4 0 0 1-2.8-.995 3.11 3.11 0 0 1 2.8-1.74c1.201 0 2.272.672 2.797 1.733A4.4 4.4 0 0 1 10 11.172M6.314 2.251a.39.39 0 0 0-.553 0L4.49 3.523l-.434-.434a.39.39 0 0 0-.553.552l.711.71a.39.39 0 0 0 .553.001l1.548-1.548a.39.39 0 0 0 0-.553"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#212121",
  d: "M4.922 0a3.207 3.207 0 0 0-3.203 3.203 3.207 3.207 0 0 0 3.203 3.203 3.207 3.207 0 0 0 3.203-3.203A3.207 3.207 0 0 0 4.922 0m0 5.625A2.425 2.425 0 0 1 2.5 3.203 2.425 2.425 0 0 1 4.922.781a2.425 2.425 0 0 1 2.422 2.422 2.425 2.425 0 0 1-2.422 2.422"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 7.972,
  height: 0.839,
  x: 6.015,
  y: 13.287,
  fill: "#212121",
  rx: 0.42
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 7.972,
  height: 0.839,
  x: 6.015,
  y: 15.105,
  fill: "#212121",
  rx: 0.42
})));
export default SvgFile;